// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3615": "995efd14","6440": "7baefc4a","9988": "b78b2a24",}[chunkId] + ".css"
}